import Login from './login';
import ROLE from './roles';
import { Api, Codes } from '../api';
// import { isSeminarOpen } from 'constants/trigger';
import Time from 'utils/time';
import DDL from './ddl';
import { Message } from 'element-ui';
import StuStateObj from './stuState';
import router from '@/router';
import Store from '@/store';
import { isFormSubmitted } from '@/store/form';
import {
  HOUSE_SORTING_DEADLINE_DDL,
  HOUSE_SORTING_OPEN_DDL
} from 'views/student/HouseSorting/constants/form';
import { HOUSE_SURVEY_FORM_NAME } from 'views/student/HouseSurvey/constants/form';

/** permission solve 失败后的统一跳转延迟（ms），便于测试看清错误提示 */
const SOLVE_REDIRECT_DELAY_MS = 2000;

function getSolveRedirectDelay(options = {}) {
  const config = options || {};
  const redirectDelay = typeof config === 'number' ? config : config.redirectDelay;
  const delay = Number(redirectDelay);

  return Number.isFinite(delay) && delay >= 0 ? delay : SOLVE_REDIRECT_DELAY_MS;
}

function getRedirectSnapshot() {
  return {
    href: window.location.href,
    routeFullPath: router?.currentRoute?.fullPath
  };
}

function isRedirectSnapshotCurrent(snapshot) {
  const currentRouteFullPath = router?.currentRoute?.fullPath;

  if (snapshot.routeFullPath && currentRouteFullPath) {
    return snapshot.routeFullPath === currentRouteFullPath;
  }

  return snapshot.href === window.location.href;
}

/**
 * @function solve
 * @description promise 扩展通用处理逻辑
 * 1. 捕获catch状态
 * 2. 弹出msg定制错误信息
 * 3. 根据错误码统一处理错误回调（默认跳转延迟 {@link SOLVE_REDIRECT_DELAY_MS}，可传 redirectDelay 覆盖）
 */
Promise.prototype.solve = function(options = {}) {
  this.catch(ex => {
    const StuObj = new StuStateObj(router);
    const redirectDelay = getSolveRedirectDelay(options);
    console.log('Promise.prototype.solve', ex);
    if (ex?.msg && ex.status !== Codes.AUTH_ERR) {
      Message.error(ex.msg);
    }

    const scheduleRedirect = callback => {
      const redirectSnapshot = getRedirectSnapshot();

      setTimeout(() => {
        if (!isRedirectSnapshotCurrent(redirectSnapshot)) {
          return;
        }

        callback();
      }, redirectDelay);
    };

    if (ex.status === Codes.AUTH_ERR) {
      scheduleRedirect(() => Login.redirectToLogin());
    } else if (ex.status === Codes.TYPE_ERROR) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.COMPLETE_INFO) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.IS_APPLIED) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.APPLY_PAID) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.TUITION_PAID) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.PLACE_DATA) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.PLACE_OPEN) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.OFFER) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.PLACE_RESULT) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.PLACE_BEIJING) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    } else if (ex.status === Codes.COURSE_RESULT) {
      scheduleRedirect(() => StuObj.stuStatusRedirect());
    }
    return ex;
  });
};

class Permission {
  constructor() {
    this.status = null;
    this.successCardStatus = null;
    this.$time = new Time();
  }
  get isCheat() {
    return !!localStorage.getItem('whosyourdaddy');
  }
  /**
   * @func isLogin 是否登陆
   * @return {Promise}
   */
  isLogin = () => {
    return new Promise((resolve, reject) => {
      if (Login.isLogin() || Login.isTeacherLogin()) {
        resolve({
          status: Codes.SUCCESS
        });
      } else {
        reject({
          status: Codes.AUTH_ERR,
          msg: '请重新登录！'
        });
      }
    });
  };
  /**
   * @func isTeacher 是否老师
   * @return {Promise}
   */
  isTeacher = async () => {
    let isLogin = await this.isLogin();
    return new Promise((resolve, reject) => {
      if (isLogin.status === Codes.SUCCESS) {
        let isTeacherLogin = Login.isLogin(ROLE.TEACHER);
        if (isTeacherLogin) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.AUTH_ERR,
            msg: '仅教师账号可查看当前页面'
          });
        }
      } else {
        reject(isLogin);
      }
    });
  };
  /**
   * @func isStudent 是否学生
   * @return {Promise}
   */
  isStudent = async () => {
    let isLogin = await this.isLogin();
    return new Promise((resolve, reject) => {
      if (isLogin.status === Codes.SUCCESS) {
        let role = Login.lastRole;
        if (role === ROLE.STUDENT) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.AUTH_ERR,
            msg: '请重新登录！!'
          });
        }
      } else {
        reject(isLogin);
      }
    });
  };
  getStudentActiveType = type => {
    let userType = type;
    if (type === 0 || type === 1 || type === 3) {
      userType = 1;
    } else if (type === 4 || type === 8 || type === 12) {
      userType = 4;
    } else {
      userType = 1;
    }
    return userType;
  };
  isStudentActiveType = async () => {
    let status = await this.getStatus();
    return new Promise((resolve, reject) => {
      if (status.status === Codes.SUCCESS) {
        let data = status.data;
        let type = this.getStudentActiveType(data.active_type);
        if (type === 1) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.TYPE_ERROR
            // msg: '无访问权限！'
          });
        }
      } else {
        reject(status);
      }
    });
  };
  isVolunteerActiveType = async () => {
    let status = await this.getStatus();
    return new Promise((resolve, reject) => {
      if (status.status === Codes.SUCCESS) {
        let data = status.data;
        let type = this.getStudentActiveType(data.active_type);
        if (type === 4) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.TYPE_ERROR
            // msg: '无访问权限！'
          });
        }
      } else {
        reject(status);
      }
    });
  };
  /**
   * @func getStatus 获取student status 数据
   * @param {Boolean} almostNew 是否保持最新
   * @return {Promise}
   */
  getStatus = async almostNew => {
    let isStudent = await this.isStudent();
    return new Promise((resolve, reject) => {
      if (isStudent.status === Codes.SUCCESS) {
        if (this.status && !almostNew) {
          resolve({
            status: Codes.SUCCESS,
            data: this.status
          });
        } else {
          almostNew = !!almostNew;
          Login.getStatusData(ROLE.STUDENT, almostNew).then(res => {
            this.status = res;
            resolve({
              status: Codes.SUCCESS,
              data: this.status
            });
          });
        }
      } else {
        reject(isStudent);
      }
    });
  };
  /**
   * @func isEB 是否EB
   * @return {Promise}
   */
  isEB = async () => {
    let status = await this.getStatus();
    return new Promise((resolve, reject) => {
      if (status.status === Codes.SUCCESS) {
        let data = status.data;
        let batch_str = data.batch_str;
        if (/eb/i.test(batch_str)) {
          resolve({
            status: Codes.SUCCESS,
            data: status.data
          });
        } else {
          reject({
            status: Codes.TYPE_ERROR,
            msg: '仅限前批I、提前批II的同学申请'
          });
        }
      } else {
        reject(status);
      }
    });
  };
  /**
   * @func getSuccessCardStatus 获取学费成功页卡片数据
   * @param {Boolean} almostNew 是否保持最新
   * @return {Promise}
   */
  getSuccessCardStatus = async almostNew => {
    let isAdmissionPaid = await this.isAdmissionPaid();
    return new Promise((resolve, reject) => {
      if (isAdmissionPaid.status === Codes.SUCCESS) {
        if (this.successCardStatus && !almostNew) {
          resolve({
            status: Codes.SUCCESS,
            data: this.successCardStatus
          });
        } else {
          Api.get
            .getStudentSuccessCardStatus()
            .then(res => {
              if (res.status === Codes.SUCCESS) {
                this.successCardStatus = res.data;
                resolve({
                  status: Codes.SUCCESS,
                  data: this.successCardStatus
                });
              } else {
                reject(res);
              }
            })
            .catch(ex => reject(ex));
        }
      } else {
        reject(isAdmissionPaid);
      }
    });
  };
  getStudentPlaceData = async () => {
    let isAdmissionPaid = await this.isAdmissionPaid();
    return new Promise((resolve, reject) => {
      if (isAdmissionPaid.status === Codes.SUCCESS) {
        Store.dispatch('getStudentPlaceData').then(res => {
          if (Object.keys(res).length > 0) {
            resolve({
              status: Codes.SUCCESS,
              data: res
            });
          } else {
            reject({
              status: Codes.PLACE_DATA,
              msg: '暂无会场信息'
            });
          }
        });
      } else {
        reject(isAdmissionPaid);
      }
    });
  };
  hasFinishInfo = async () => {
    let statusRes = await this.getStatus();
    return new Promise((resolve, reject) => {
      if (statusRes.status === Codes.SUCCESS) {
        let data = statusRes.data;
        if (data?.activate_status_v5?.info_completed) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.COMPLETE_INFO,
            msg: '未完善信息填写，请完善信息后查看'
          });
        }
      } else {
        reject(statusRes);
      }
    });
  };
  /**
   * @func hasOffer 是否有offer
   * @return {Promise}
   */
  hasOffer = async () => {
    let status = await this.getStatus();
    return new Promise((resolve, reject) => {
      if (status.status === Codes.SUCCESS) {
        let data = status.data;
        let offer_letter = data.offer_letter;
        if (offer_letter) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.OFFER,
            msg: '仅限被录取并支付费用的用户访问'
          });
        }
      } else {
        reject(status);
      }
    });
  };
  isStudentType = async () => {
    let status = await this.getStatus();
    return new Promise((resolve, reject) => {
      if (status.status === Codes.SUCCESS) {
        let data = status.data;
        let active_type = data.active_type;
        if (active_type === 1 || active_type === 3) {
          resolve({
            status: Codes.SUCCESS,
            data: status.data
          });
        } else {
          reject({
            status: Codes.TYPE_ERROR,
            msg: '仅中学生可游览'
          });
        }
      } else {
        reject(status);
      }
    });
  };
  /**
   * @func isStuApplied 学生是否完成了第二步申请
   * @return {Promise}
   */
  isStuApplied = async () => {
    let studentTypeStatus = await this.isStudentType();
    return new Promise((resolve, reject) => {
      if (studentTypeStatus.status === Codes.SUCCESS) {
        let data = studentTypeStatus.data;
        let is_step2_applied = data?.apply_v5?.step2_submitted;
        if (is_step2_applied) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.IS_APPLIED,
            msg: '未完成申请，暂时无法查看'
          });
        }
      } else {
        reject(studentTypeStatus);
      }
    });
  };
  /**
   * @func hasApplyPaid 是否已支付申请费
   * @return {Promise}
   */
  hasApplyPaid = async () => {
    let status = await this.getStatus();
    return new Promise((resolve, reject) => {
      if (status.status === Codes.SUCCESS) {
        let data = status.data;
        let is_apply_paid = data.is_apply_paid;
        if (is_apply_paid) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.APPLY_PAID,
            msg: '请先支付申请费！'
          });
        }
      } else {
        reject(status);
      }
    });
  };
  /**
   * @func hasPaidTuition 是否支付学费
   * @return {Promise}
   */
  hasPaidTuition = async () => {
    let status = await this.getStatus();
    return new Promise((resolve, reject) => {
      if (status.status === Codes.SUCCESS) {
        let data = status.data;
        let is_tuition_paid = data.is_tuition_paid;
        if (is_tuition_paid) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.TUITION_PAID,
            msg: '无访问权限！'
          });
        }
      } else {
        reject(status);
      }
    });
  };
  /**
   * @func isAdmissionPaid 是否已录取并支付学费
   * @return {Promise}
   */
  isAdmissionPaid = () => {
    return new Promise((resolve, reject) => {
      Promise.all([this.hasOffer(), this.hasPaidTuition()])
        .then(res => {
          resolve({
            status: Codes.SUCCESS
          });
        })
        .catch(ex => reject(ex));
    });
  };
  /**
   * @func hasPlaceResult 是否已公布会场
   * @return {Promise}
   */
  hasPlaceResult = async () => {
    let successCardStatus = await this.getSuccessCardStatus();
    return new Promise((resolve, reject) => {
      if (successCardStatus.status === Codes.SUCCESS) {
        let data = successCardStatus.data;
        let hasPlaceName = !!data.course_apply?.place_name;
        if (hasPlaceName) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.PLACE_RESULT,
            msg: '会场结果公布后，开放访问'
          });
        }
      } else {
        reject(successCardStatus);
      }
    });
  };
  /**
   * @func hasCourseResult 是否已公布选课结果
   * @return {Promise}
   */
  hasCourseResult = async () => {
    let status = await this.getStatus();
    return new Promise((resolve, reject) => {
      if (status.status === Codes.SUCCESS) {
        if (status.data?.has_course_result) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.COURSE_RESULT,
            msg: '选课结果公布后，开放访问'
          });
        }
      } else {
        reject(status);
      }
    });
  };
  /**
   * @func placeNameResult 会场结果
   * @return {Promise}
   */
  placeNameResult = async () => {
    let successCardStatus = await this.getSuccessCardStatus();
    return new Promise((resolve, reject) => {
      if (successCardStatus.status === Codes.SUCCESS) {
        let data = successCardStatus.data;
        let hasPlaceName = data.course_apply?.place_name || '';
        if (hasPlaceName) {
          resolve(hasPlaceName);
        } else {
          resolve('');
        }
      } else {
        reject(successCardStatus);
      }
    });
  };
  /**
   * @func isAllowCourseCart 是否可选课
   * @return {Promise}
   */
  isAllowCourseCart = async () => {
    let successCardStatus = await this.getSuccessCardStatus();
    return new Promise((resolve, reject) => {
      if (successCardStatus.status === Codes.SUCCESS) {
        let data = successCardStatus.data;
        if (data.allow_course_cart) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.PLACE_RESULT,
            msg: '用户尚未开放选课！'
          });
        }
      } else {
        reject(successCardStatus);
      }
    });
  };
  /**
   * @description 峰会现场是否开始
   * @return {Promise}
   */
  isHsylcStart = async () => {
    let successCardStatus = await this.getSuccessCardStatus();
    const ddls = await DDL.getDDLData();
    return new Promise((resolve, reject) => {
      if (successCardStatus.status === Codes.SUCCESS) {
        const data = successCardStatus.data;
        const placeName = data?.course_apply?.place_name;
        const startTime = ddls[`${placeName}会场开放`];
        let isStart = this.isCheat ? true : startTime && this.$time.isOverDate(startTime);
        // isStart = false; // 先关闭
        if (isStart) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.ERR,
            msg: '暂未开放'
          });
        }
      } else {
        reject(successCardStatus);
      }
    });
  };
  /**
   * @description 峰会现场是否结束
   * @return {Promise}
   */
  isHsylcEnd = async () => {
    let successCardStatus = await this.getSuccessCardStatus();
    const ddls = await DDL.getDDLData();
    return new Promise((resolve, reject) => {
      if (successCardStatus.status === Codes.SUCCESS) {
        const data = successCardStatus.data;
        const placeName = data?.course_apply?.place_name;
        const endTime = ddls[`${placeName}会场结束`];
        let isEnd = this.isCheat ? true : endTime && this.$time.isOverDate(endTime);
        if (isEnd) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.ERR,
            msg: '暂未开放'
          });
        }
      } else {
        reject(successCardStatus);
      }
    });
  };
  /**
   * @description HXWeek有录取信
   * @return {Promise}
   */
  hasHXWeekOffer = async () => {
    let successCardStatus = await this.getSuccessCardStatus();
    return new Promise((resolve, reject) => {
      if (successCardStatus.status === Codes.SUCCESS) {
        const data = successCardStatus.data;
        const offerType = data.hxweek_offer_letter?.offer_type;
        let hasOffer = this.isCheat ? true : offerType === 'hweek' || offerType === 'xweek';
        if (hasOffer) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.ERR,
            msg: '暂未开放'
          });
        }
      } else {
        reject(successCardStatus);
      }
    });
  };
  /**
   * @description HXWeek是否付费
   * @param {String} [offerType] 限定录取项目类型
   * @return {Promise}
   */
  isHXWeekPaid = async offerType => {
    let successCardStatus = await this.getSuccessCardStatus();
    return new Promise((resolve, reject) => {
      if (successCardStatus.status === Codes.SUCCESS) {
        const data = successCardStatus.data;
        const currentOfferType = data.hxweek_offer_letter?.offer_type;
        const isOfferTypeMatched = !offerType || currentOfferType === offerType;
        let isPaid = this.isCheat ? true : isOfferTypeMatched && data.hxweek_paid_status?.fee === 1;
        if (isPaid) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: offerType ? Codes.OFFER : Codes.ERR,
            msg: offerType
              ? (isOfferTypeMatched ? '完成定金支付后，方可访问' : `仅限${offerType.toUpperCase()}录取用户访问`)
              : '暂未开放'
          });
        }
      } else {
        reject(successCardStatus);
      }
    });
  };
  isBeijing = async () => {
    let placeDataRes = await this.getStudentPlaceData();
    return new Promise((resolve, reject) => {
      if (placeDataRes.status === Codes.SUCCESS) {
        let place_name = placeDataRes.data?.course_apply?.place_name;
        if (place_name === '北京') {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.PLACE_BEIJING,
            msg: '仅限北京会场'
          });
        }
      } else {
        reject(placeDataRes);
      }
    });
  };
  isPlaceOpen = async () => {
    // return new Promise((resolve, reject) => {
    //   reject({
    //     status: Codes.PLACE_OPEN,
    //     msg: '暂未开放'
    //   });
    // });
    let placeDataRes = await this.getStudentPlaceData();
    return new Promise((resolve, reject) => {
      if (placeDataRes.status === Codes.SUCCESS) {
        let open_at = placeDataRes.data?.place_apply?.open_at;
        if (open_at && this.$time.isOverDate(open_at)) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.PLACE_OPEN,
            msg: '暂未开放'
          });
        }
      } else {
        reject(placeDataRes);
      }
    });
  };
  isSeminarOpen = async () => {
    let placeDataRes = await this.getStudentPlaceData();
    return new Promise((resolve, reject) => {
      if (placeDataRes.status === Codes.SUCCESS) {
        let open_at = placeDataRes.data?.course_apply?.open_at;
        let place_name = placeDataRes.data?.course_apply?.place_name;
        let msg = '';
        let isOpen = open_at && this.$time.isOverDate(open_at);
        if (!isOpen) {
          msg = '选课未开放';
        } else if (!place_name) {
          msg = '请在公布会场结果后选课';
        }
        if (isOpen && place_name) {
          resolve({
            status: Codes.SUCCESS
          });
        } else {
          reject({
            status: Codes.PLACE_OPEN,
            msg: msg
          });
        }
      } else {
        reject(placeDataRes);
      }
    });
  };
  hasHouseResult = async () => {
    return new Promise((resolve, reject) => {
      Promise.all([this.getSuccessCardStatus(), this.hasPlaceResult()])
        .then(res => {
          let successCardStatus = res[0];
          if (successCardStatus.status === Codes.SUCCESS) {
            const data = successCardStatus.data;
            let house = data?.user?.house;
            if (house) {
              resolve({
                status: Codes.SUCCESS
              });
            } else {
              reject({
                status: Codes.PLACE_RESULT,
                msg: '尚未公布house信息！'
              });
            }
          } else {
            reject(successCardStatus);
          }
        })
        .catch(ex => {
          reject(ex);
        });
    });
  };
  /**
   * 分院问卷（分院问卷_2026）是否已提交。
   *
   * @returns {Promise}
   */
  hasHouseSurveyCompleted = async () => {
    await Store.dispatch('getFormData', {
      id: HOUSE_SURVEY_FORM_NAME,
      force: true
    });

    return new Promise((resolve, reject) => {
      const formRecord = Store.state.Form.forms[HOUSE_SURVEY_FORM_NAME];

      if (isFormSubmitted(formRecord)) {
        resolve({
          status: Codes.SUCCESS
        });
      } else {
        reject({
          status: Codes.PLACE_OPEN,
          msg: '请先完成分院问卷'
        });
      }
    });
  };
  canSorting = async () => {
    return new Promise((resolve, reject) => {
      Promise.all([
        this.isBeijing(),
        // 不再门闸 hasHouseResult：其读 success-card 的 user.house（受「{会场}House公布」DDL 控制），
        // 分院测试已开但 House 未公布时会误拦并 toast「尚未公布house信息！」。
        // 提交仍由后端校验 activate.house（SortingController::store）。
        // this.hasHouseResult(),
        this.hasHouseSurveyCompleted()
      ])
        .then(async () => {
          const isOpen = await DDL.isOver(HOUSE_SORTING_OPEN_DDL);

          if (!isOpen) {
            reject({
              status: Codes.PLACE_OPEN,
              msg: '暂未开放'
            });
            return;
          }

          const [isDeadlineOver, sortingRes] = await Promise.all([
            DDL.isOver(HOUSE_SORTING_DEADLINE_DDL),
            Api.get.getStudentHouseSorting()
          ]);
          const sortingQa = sortingRes?.status === Codes.SUCCESS ? sortingRes.data?.qa || {} : {};
          const isCompleted = !!(sortingQa.submitted_at && sortingQa.suggest_house);

          if (isDeadlineOver && !isCompleted) {
            reject({
              status: Codes.PLACE_OPEN,
              msg: '截止时间已过'
            });
            return;
          }

          resolve({
            status: Codes.SUCCESS
          });
        })
        .catch(ex => reject(ex));
    });
  };
}

export default new Permission();
